const events = [
  {
    title: "Fajr",
    description: "Waking the community for the dawn prayer",
    completed: false, // added property
  },
  {
    title: "Sermon",
    description:
      "Participation in a short educational sermon after the dawn prayer",
    completed: false, // added property
  },
  {
    title: "Lessons",
    description:
      "Religious Lesson during the day. Either at home, work or in a place of worship",
    completed: false, // added property
  },
  {
    title: "Teach/Learn Quran",
    description:
      "Teaching or learning Quran recitation. At least 4 days a week.",
    completed: false, // added property
  },
  {
    title: "Individual Efforts",
    description:
      "Spending time, one-to-one with members of the community to encourage their support of the activities and goals of Dawat-e-Islami.",
    completed: false, // added property
  },
  {
    title: "Watch Programme",
    description:
      "Watching Madani Muzakrah programme on Madani channel every Saturday",
    completed: false, // added property
  },
  {
    title: "Weekly Gathering",
    description:
      "Participation in a Weekly Gathering in a Mosque every Thursday evening",
    completed: false, // added property
  },
  {
    title: "Visiting Community",
    description:
      "Visiting the local community throughout the week and inviting people towards righteousness (good deeds).",
    completed: false, // added property
  },
  {
    title: "Reading Booklet",
    description:
      "Reading the Weekly-booklet which is printed by the publishing dept of Dawat-e-Islami.",
    completed: false, // added property
  },
  {
    title: "Spend Time",
    description:
      "Spending time within a mosque between two separate congregational prayers.",
    completed: false, // added property
  },
  {
    title: "3-Day Stay",
    description:
      "A monthly spiritual-retreat -spending at least 3-days every month, living in a mosque with the intention of gaining religious knowledge.",
    completed: false, // added property
  },
  {
    title: "App/Booklet",
    description:
      "Filling out the Pious Deeds app/booklet everyday of the month and then submitting the completed document to the appointed supervisor.",
    completed: false, // added property
  },
];
//12 events

export default events;
//allow me to use this file in other files^
